import { render, staticRenderFns } from "./priceListseahourse.vue?vue&type=template&id=1bfeb102&"
import script from "./priceListseahourse.vue?vue&type=script&lang=js&"
export * from "./priceListseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports